import {
    ChangeDetectionStrategy, Component, Input
} from "@angular/core";

/**
 * Small presentational indicator that renders either a numeric count pill or a bare required asterisk.
 *
 * - `count` variant: renders a rounded pill containing `count`. Nothing is rendered (the element is absent from the
 *   DOM, not hidden) when `count` is falsy (`0` / `undefined`).
 * - `required` variant: renders an asterisk in the theme's error (danger) colour (`--mat-sys-error`).
 *   Use it where Material provides no marker of its own (for example a stepper step label).
 *
 * The indicator sits in normal flex flow as a trailing inline element; it uses no absolute positioning.
 *
 * @example
 * ```html
 * <mgd-indicator variant="count" [count]="selectedCount"></mgd-indicator>
 * <mgd-indicator variant="required"></mgd-indicator>
 * ```
 *
 * @selector mgd-indicator
 */
@Component({
    selector: "mgd-indicator",
    templateUrl: "./indicator.component.html",
    styleUrl: "./indicator.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IndicatorComponent {

    /**
     * Which indicator to render. Defaults to `count`.
     */
    @Input() variant: "count" | "required" = "count";

    /**
     * The number shown in the pill. Read only when `variant` is `count`; the pill is not rendered when falsy.
     */
    @Input() count?: number;

}
